export const RefinancePropsMixin = {
    props: {
        loan: {
            type: Object,
            required: true
        },
        payoff: {
            type: Number,
            required: true
        },
        loanAmount: {
            type: Number,
            required: true
        },
        maxCashBack: {
            type: Number,
            required: true
        },
        paymentAmount: {
            type: Number,
            default: 50
        },
        advancedRefi: {
            type: Boolean,
            default: false
        },
        advancedRefiRate: {
            type: Number,
            default: null
        },
        currentRate: {
            type: Number,
            default: null
        },
        advancedRefiTerm: {
            type: Number,
            default: null
        },
        advancedRefiPayment: {
            type: Number,
            default: null
        },
        currentPayment: {
            type: Number,
            default: null
        },
        advancedRefiMaxCashBack: {
            type: Number,
            default: null
        },
        showPhase2Teaser: {
            type: Boolean,
            default: false
        },
        paybackPct: {
            type: Number,
            default: 0
        },
        targetPct: {
            type: Number,
            default: 0
        },
        previewBetterRate: {
            type: Number,
            default: null
        },
        previewBalanceBonus: {
            type: Number,
            default: 0
        },
        paymentsMade: {
            type: Number,
            default: 0
        },
        totalPayments: {
            type: Number,
            default: 0
        },
        paidPayments: {
            type: Number,
            default: 0
        },
        totalSchedulePayments: {
            type: Number,
            default: 0
        },
        paymentsRemaining: {
            type: [Number],
            default: null,
            validator: value => value === null || typeof value === 'number'
        },
        advancedRefiFrozen: {
            type: Boolean,
            default: false
        },
        advancedRefiAvailableAt: {
            type: String,
            default: ''
        },
        advancedRefiFrozenDaysRemaining: {
            type: Number,
            default: 0
        },
        hasMissedPayments: {
            type: Boolean,
            default: false
        },
        missedPaymentWarning: {
            type: Object,
            default: null
        },
        maxTermMonths: {
            type: Number,
            default: 24
        },
        portalUrl: {
            type: String,
            default: 'https://portal.steppingstoneloans.com'
        },
        previewTermMonths: {
            type: Number,
            default: 24
        },
        currentTermMonths: {
            type: Number,
            default: 12
        },
        eligible: {
            type: Boolean,
            default: true
        },
        message: {
            type: String,
            default: ''
        },
        noPayrollTitle: {
            type: String,
            default: "We couldn't find your recent payroll"
        },
        noPayroll: {
            type: Boolean,
            default: false
        },
        supportEmail: {
            type: String,
            default: 'support@steppingstoneloans.com'
        },
        changeBankUrl: {
            type: String,
            default: ''
        }
    },
};
